import ServicesApi from './ServicesApi';
import DateTimeUtils from '../common/utils/DateTimeUtils';

export default class ScheduleApi {
  static servicePrefix = 'scheduleservice/';

  static async getFullUpdate(counterpartyCode, currentMonth) {
    const headers = await ServicesApi.getHeaders();

    const updateResponse = await fetch(
      ScheduleApi.servicePrefix + 'fullupdate?counterpartyCode=' + counterpartyCode
      + '&queryMonth=' + encodeURIComponent(DateTimeUtils.formatDateForQuery(currentMonth)), {
      method: 'GET',
      headers: headers
    });

    return await updateResponse.json();
  }

  static async getPreschedulePackageDates(counterpartyCode, tradingDate) {
    const headers = await ServicesApi.getHeaders();

    const updateResponse = await fetch(
      ScheduleApi.servicePrefix + 'preschedulePackageDates?counterpartyCode=' + counterpartyCode
      + '&tradingDate=' + encodeURIComponent(DateTimeUtils.formatDateForQuery(tradingDate)), {
      method: 'GET',
      headers: headers
    });

    return await updateResponse.json();
  }

  static async getPartialUpdate(counterpartyCode, currentMonth, lastRetrievalTimeUtc) {
    const headers = await ServicesApi.getHeaders();

    var url = ScheduleApi.servicePrefix + 'partialupdate?counterpartyCode=' + counterpartyCode
      + '&queryMonth=' + encodeURIComponent(DateTimeUtils.formatDateForQuery(currentMonth))
      + '&lastRetrievalTimeUtc=' + encodeURIComponent(lastRetrievalTimeUtc);

    const updateResponse = await fetch(
      url, {
      method: 'GET',
      headers: headers
    });

    return await updateResponse.json();
  }

  static async submitChanges(counterpartyCode, dateSubmissions, onSubmitFinished, isNotifyEnabled) {
    const headers = await ServicesApi.getHeaders();

    var scheduleSubmissions = {
      counterpartyCode: counterpartyCode,
      dateSubmissions: dateSubmissions,
      isNotifyEnabled: isNotifyEnabled
    }

    fetch(
      ScheduleApi.servicePrefix + 'submit', {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(scheduleSubmissions)
    }).then(onSubmitFinished);
  }

  static async resubmit(counterpartyCode, contractCodes, rangeFirstDate, rangeLastDate, submitPrinceTrades, submitSata, onSubmitFinished) {
    const headers = await ServicesApi.getHeaders();

    var url = ScheduleApi.servicePrefix + 'resubmit?counterpartyCode=' + counterpartyCode
      + '&contractCodes=' + contractCodes.join(';')
      + '&rangeFirstDate=' + encodeURIComponent(DateTimeUtils.formatDateForQuery(rangeFirstDate))
      + '&rangeLastDate=' + encodeURIComponent(DateTimeUtils.formatDateForQuery(rangeLastDate))
      + '&submitPrinceTrades=' + (submitPrinceTrades ? 'true' : 'false')
      + '&submitSata=' + (submitSata ? 'true' : 'false');

    fetch(
      url, {
      method: 'PUT',
      headers: headers
    }).then(onSubmitFinished);
  }

  static async recalculate(counterpartyCode, contractCodes, rangeFirstDate, rangeLastDate, submitPrinceTrades, submitSata, onSubmitFinished) {
    const headers = await ServicesApi.getHeaders();

    var url = ScheduleApi.servicePrefix + 'recalculate?counterpartyCode=' + counterpartyCode
      + '&contractCodes=' + contractCodes.join(';')
      + '&rangeFirstDate=' + encodeURIComponent(DateTimeUtils.formatDateForQuery(rangeFirstDate))
      + '&rangeLastDate=' + encodeURIComponent(DateTimeUtils.formatDateForQuery(rangeLastDate))
      + '&submitPrinceTrades=' + (submitPrinceTrades ? 'true' : 'false')
      + '&submitSata=' + (submitSata ? 'true' : 'false');

    fetch(
      url, {
      method: 'PUT',
      headers: headers
    }).then(onSubmitFinished);
  }
}